import { BuilderConfig } from '../../types/Builder';

import BusinessHubIndustriesCarousel from './business-hub-industries-carousel';

export const BusinessHubIndustriesCarouselBuilderConfig = {
    name: 'Business Hub Industries Carousel',
    inputs: [],
};

const builderConfig: BuilderConfig<{}> = {
    component: BusinessHubIndustriesCarousel,
    config: BusinessHubIndustriesCarouselBuilderConfig,
};

export default builderConfig;
